import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles((theme) => ({
  checkList: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 8,
    alignItems: 'flex-start',
  },
  optionWithPeriod: {
    borderRadius: 4,
    border: `1px solid ${theme.palette.grey[300]}`,
    width: '100%',
    padding: 4,
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8,
    '& div': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  periodLabel: {
    flexGrow: 1,
    paddingRight: 10,
    textAlign: 'right',
    lineHeight: '220%',
  },
  periodContainer: {
    maxWidth: 300,
    '& .DayPicker__horizontal': {
      width: '650px !important',
    },
  },
  alertDate: {
    width: '100%',
    marginTop: 8,
  },
  alertEmail: {
    marginTop: 8,
  },
}));

export default styles;
